{
    "webshop_offer_voucher_correctCode": "Código correto inserido",
    "webShop_howToFindId_desc": "Você pode encontrar e copiar sua ID pessoal no seu perfil de jogador.",
    "webShop_howToFindId_link": "Onde encontro minha ID pessoal?",
    "webshop_offer_voucher_codeIsIncorrect": "Código incorreto",
    "webshop_offer_voucher_enterYourCode": "Insira sua ID pessoal",
    "webShop_unexpectedError_desc": "Erro inesperado. Tente novamente mais tarde.",
    "webShop_accountBanned_desc": "Conta banida!",
    "webshop_confirm": "OK",
    "webshop_termsConditions_1": "Termos e Condições",
    "webshop_purchase_privacyPolicy": "Política de Privacidade",
    "webshop_legal_1": "Legal",
    "webshop_support_1": "Suporte",
    "mbs_access_welcome_desc": "Bem-vindo, {0}",
    "btn_login": "Login",
    "mbs_access_error_sessionExpired_desc": "Sua sessão expirou. Insira sua ID de conta manualmente."
}
